import { Typography as MuiTypography, styled } from '@material-ui/core';

import { COLORS } from 'theme/constants';

export const Typography = styled(MuiTypography)({
  '&.info': { color: COLORS.greyText },
});
